import React from "react";
import "./Services.css";

export const Services = () => {
  const servicesData = [
    {
      name: "Solar Installation",
      description: "Professional installation of residential and commercial solar systems with 25-year performance guarantee.",
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
    },
    {
      name: "Solar Maintenance",
      description: "Regular maintenance packages to keep your system running at peak efficiency with 24/7 monitoring.",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
    },
    {
      name: "Site Inspection",
      description: "Comprehensive evaluation of your property with 3D modeling for optimal solar placement.",
      image: "https://images.unsplash.com/photo-1521618755572-156ae0cdd74d?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
    },
    {
      name: "Get a Quote",
      description: "Personalized solar solutions with transparent pricing and government subsidy assistance.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
    },
    {
      name: "Energy Consultation",
      description: "Expert advice on energy savings, system sizing, and return on investment calculations.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
    },
    {
      name: "Battery Storage",
      description: "Tesla Powerwall and other storage solutions to maximize your energy independence.",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        
        <div className="section-title services-header">
          <h2>Our Solar Services</h2>
          <p>Premium solar solutions designed for maximum efficiency and long-term savings</p>
       
        </div>
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={`${service.name}-${index}`} className="service-card">
              <div className="service-image-container">
                <img 
                  src={service.image} 
                  alt={service.name}
                  className="service-image"
                  loading="lazy"
                />
              </div>
              <div className="service-content">
                <h3>{service.name}</h3>
                <p>{service.description}</p>
                <button className="service-button">View More</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};